import {APIService} from '@/services/api.service';
import {SolutionResponse} from '../solution/solution-support.types';

export enum LunchTime {
  ANY = 'Any',
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  EVENING = 'Evening',
  NIGHT = 'Night',
  NONE = '',
}
export interface IRescheduleActivityRequest {
  solutionId: string;
  activityId: string;
  sessionId: string;
  problemId: string;
  startTime: number;
  endTime: number;
  dinnerPreference: LunchTime;
}

export async function rescheduleActivity(payload: IRescheduleActivityRequest): Promise<SolutionResponse | null> {
  try {
    const activity_keyword = payload.dinnerPreference ? payload.dinnerPreference.toUpperCase() : '';
    const res = await APIService.post<SolutionResponse>(
      'alternative-timeslot',
      {activity_keyword},
      {
        params: {
          session_id: payload.sessionId,
          problem_id: payload.problemId,
          solution_id: payload.solutionId,
          activity_id: payload.activityId,
          earliest_time: payload.startTime,
          latest_time: payload.endTime,
        },
      },
    );
    return res;
  } catch (e) {
    return null;
  }
}
